import axios from "../axios";

export function inviteMembers(email, domain, invitedEmails, userPoolId, invitedFrom) {
    return axios.post(`invites`, { inviterEmail: email, envDomain: domain, userEmails: invitedEmails, userPoolId, inviteContext : invitedFrom }).then(({ data }) => data);
}

export function updateInvitedMemberDetails(email, envDomain, firstName, lastName, role) {
    return axios.put(`invites/${encodeURIComponent(email)}`, { tenantName: envDomain, firstName, lastName, role }).then(({ data }) => data);
}
